import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Author: Mohd Azrul Hadi Abd Aziz
 * 
 * Date Created: October 27th 2018
 * 
 * Description: Component class to sanitize/trust HTML content
 **/
@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(html) {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
}


// WEBPACK FOOTER //
// ./src/app/pipe/safe-html.pipe.ts